import React from 'react';

import cn from 'classnames';

import { TEventWeather } from '@entities/eventJournal/model/types';
import { UiText } from '@shared/ui';
import { WeatherBlock } from '@widgets/EventJournal/ui/WeatherBlock/WeatherBlock';

import cls from './EventJournalItemListHeader.module.css';

interface EventItemListHeaderProps {
    classes?: string;
    title: string;
    isExport?: boolean;
    weatherData?: TEventWeather;
}

export const EventJournalItemListHeader = ({
    classes,
    title,
    isExport,
    weatherData,
}: EventItemListHeaderProps) => (
    <div className={cn(cls.EventItemListHeader, [classes])}>
        <UiText variant="subHeading" tag="h2" weight="bold" classes={isExport && cls.exportDate}>
            {title}
        </UiText>
        {weatherData && (
            <WeatherBlock
                temperature={weatherData.temperature}
                iconUrl={weatherData.iconImageUrl}
            />
        )}
    </div>
);
